module.exports = __webpack_public_path__ + "img/button_default_01.efce63a3.png";